"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/Disposable
 */

/**
 * @classdesc
 * Objects that need to clean up after themselves.
 */
var Disposable =
/** @class */
function () {
  function Disposable() {
    /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */
    this.disposed = false;
  }
  /**
   * Clean up.
   */


  Disposable.prototype.dispose = function () {
    if (!this.disposed) {
      this.disposed = true;
      this.disposeInternal();
    }
  };
  /**
   * Extension point for disposable objects.
   * @protected
   */


  Disposable.prototype.disposeInternal = function () {};

  return Disposable;
}();

var _default = Disposable;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7QUFJQTtBQUFBO0FBQUE7RUFDRTtJQUNFOzs7OztJQUtBLEtBQUtBLFFBQUwsR0FBZ0IsS0FBaEI7RUFDRDtFQUVEOzs7OztFQUdBQztJQUNFLElBQUksQ0FBQyxLQUFLRCxRQUFWLEVBQW9CO01BQ2xCLEtBQUtBLFFBQUwsR0FBZ0IsSUFBaEI7TUFDQSxLQUFLRSxlQUFMO0lBQ0Q7RUFDRixDQUxEO0VBT0E7Ozs7OztFQUlBRCxvREFBb0IsQ0FBcEI7O0VBQ0Y7QUFBQyxDQXpCRDs7ZUEyQmVBLFUiLCJuYW1lcyI6WyJkaXNwb3NlZCIsIkRpc3Bvc2FibGUiLCJkaXNwb3NlSW50ZXJuYWwiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL0Rpc3Bvc2FibGUuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=